import { render, staticRenderFns } from "./ChartLiantong.vue?vue&type=template&id=445a80f2&"
import script from "./ChartLiantong.vue?vue&type=script&lang=js&"
export * from "./ChartLiantong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports